import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng';

@Component({
  selector: 'supplier-invoices',
  templateUrl: './supplier-invoices.component.html',
})
export class SupplierInvoicesComponent implements OnInit {
  constructor(
    public messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {}
}
